import { useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import ehliyetOptions from "../../utils/ehliyetOptions"
import srcOptions from "../../utils/srcOptions"
import locationData from "../../utils/locationData/locationOptions"
import moment from "moment"
import Btn from "../shared/button/Btn"
import InputText from "../shared/input/new/InputText"
import InputDate from "../shared/input/new/InputDate"
import InputSelectMultiple from "../shared/input/new/InputSelectMultiple"
import InputCityTown from "../shared/input/new/InputCityTown"
import InputTextarea from "../shared/input/new/InputTextarea"
import dateConverter from "../../helper/dateConverter"
import { getUserTcApprove, getUserTcNoUnique } from "../../features/admin2/admin2Slice"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import {MdCheck} from "react-icons/md"
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .top-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-bottom: 5px;
        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

        h4{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-md);
        }

        .update-text{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: var(--color-main);
            text-decoration: underline;
            cursor: pointer;

        }
    }

    .main-content{
        display: flex;
        gap: 8px;

        .content-grp{
            width: 50%;
            display: flex;
            flex-direction: column;

            .content-item{
                width: 100%;
                display: flex;
                align-items: center;
                width: 100%;
                padding: 8px;
                border-radius: 5px;

                &:hover{
                    background-color: ${({theme}) => theme.secondaryBgColor};
                }

                .key{
                    width: 40%;
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-sm);
                }

                .row{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 54%;
                }

                .value{
                    width: 60%;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-sm);
                    display: flex;

                    .tc-dogrula-btn{
                        color: var(--color-main);
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                        padding-left: 20px;
                        cursor: pointer;
                        display: flex;
                        flex-direction: row;
                        text-decoration: underline !important;

                        .tc-checked{
                            color: var(--color-green);
                            display: flex;
                            align-items: center;
                            gap: 5px;
                        }

                        .tc-checked-icon{
                            font-size: 1rem;
                        }
                    }

                    .tc-dogrula-btn-passive {
                        cursor: initial !important;
                        text-decoration: none !important;
                    }
                }

                .phone-number-sorgula{
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
    }
    .button-grp{
        width: 100%;
        display: flex;
        justify-content: center !important;
        margin-top: auto;
        margin: 30px 0;
        gap: 50px;
    }
`


const RegularDriverItemInfos = ({uyeItemData}) => {

      const [isUpdateContent, setIsUpdateContent] = useState(false)

      
  
      const dispatch = useDispatch()
  
      const ehliyets = uyeItemData?.ehliyetTypes.$values.map(item => item.ehliyet)
      const srcs = uyeItemData?.srcTypes?.$values.map(item => item.srcBelgesi)

      const [phoneNumber, setPhoneNumber] = useState(uyeItemData.phoneNumber)
      const [tckn, setTckn] = useState(uyeItemData.tckn)
      const [adSoyadUnvan, setAdSoyadUnvan] = useState(uyeItemData.adSoyadUnvan)
      const [dogumTarihi, setDogumTarihi] = useState(uyeItemData.dogumTarihi)
      const [adressContent, setAdressContent] = useState(uyeItemData.adressContent)

      const [location, setLocation] = useState("")

      
      const { isLoadingGetUserTcApprove, userTCApprovedResData, userPhoneNumberUniqueResData, userTcNoUniqueResData } = useSelector(state => state.admin2)
  
  
      const [ehliyetTypes, setEhliyetTypes] = useState(ehliyetOptions.filter(item => ehliyets?.includes(item.value)))
      const [srcTypes, setSrcTypes] = useState(srcOptions?.filter(item => srcs?.includes(item.value)).length > 0 ? srcOptions?.filter(item => srcs?.includes(item.value)) : [srcOptions[srcOptions.length-1]])

      
      const [cityTown ,setCityTown] = useState(locationData?.find(item => (item.city?.toLocaleLowerCase("tr") === uyeItemData?.il?.toLocaleLowerCase("tr")) && (item.town?.toLocaleLowerCase("tr") === uyeItemData?.ilce?.toLocaleLowerCase("tr"))))
    //   const [referanceStatus, setReferanceStatus] = useState(referanceCardData.find(item => item.value === uyeItemData?.IsReferenceCard))
  
  
      const handleSubmit = () => {
  
      }
    
  return (
    <Container>
        <div className="top-container">
            {/* <div className="placeholder"/> */}
            <h4>Üye Bilgileri</h4>
            {/* <span className="update-text" onClick={() => setIsUpdateContent(!isUpdateContent)}>{!isUpdateContent ? "Güncelle" : "Detayları Görüntüle"}</span> */}
        </div>
        <div className="main-content">
            <div className="content-grp">
                <div className="content-item">
                    <div className="key">Ad Soyadı*:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{adSoyadUnvan}</div>
                        :
                        <InputText data={adSoyadUnvan} setData={(e) =>setAdSoyadUnvan(e.target.value)} inputWidth={"320px"} labelText="" name={"adSoyadUnvan"}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Telefon*:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{phoneNumber}</div>
                        :
                        <div className="row">
                            <InputText data={phoneNumber} setData={(e) =>setPhoneNumber(e.target.value)} inputWidth={"200px"} labelText="" name={"phoneNumber"}/>
                        </div>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Doğum Tarihi:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{dateConverter(dogumTarihi, "tr")}</div>
                        :
                        <InputDate data={dogumTarihi} setData={(e) =>setDogumTarihi(e.target.value)} inputWidth={"320px"} labelText="" name={"dogumTarihi"}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">TC No*:</div>
                    {
                        !isUpdateContent ? 
                            // <div className="value">{tckn} <span onClick={() => !uyeItemData.isTcNoValid && dispatch(getUserTcApprove({id: uyeItemData.id, tckn: tckn, adSoyadUnvan: adSoyadUnvan, dogumTarihi: dogumTarihi}))} className={uyeItemData.isTcNoValid ? "tc-dogrula-btn tc-dogrula-btn-passive" : "tc-dogrula-btn"}>{false ? <SmallSpinner size={"10px"} color={"#fff"} bgColor={"#E85446"}/> : uyeItemData.isTcNoValid ? <span className="tc-checked">Doğrulandı <MdCheck className="tc-checked-icon"/></span> : <span>Doğrula</span> }</span></div>
                            <div className="value">{tckn}</div>
                        :
                        <div className="row">
                            <InputText data={tckn} setData={(e) =>setTckn(e.target.value)} inputWidth={"200px"} labelText="" name={"tckn"}/>
                            {/* {uyeItemData?.tckn !== formData?.tcNo && <Btn color="#E85446" bgColor="transparent" padding="10px" handleClick={() => dispatch(getUserTcNoUnique(formData?.tcNo))} >Kontrol Et</Btn> }  */}
                        </div>
                        }
                </div>
                <div className="content-item">
                    <div className="key">Ehliyet Türü:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{ehliyetTypes.map((item, i) => i+1 === ehliyetTypes.length ? item.value : `${item.value}, ` )}</div>
                        :
                        <InputSelectMultiple data={ehliyetTypes} setData={setEhliyetTypes} inputWidth={"320px"} labelText="" name={"ehliyetTypes"} options={ehliyetOptions}/>
                    }

                </div>
                <div className="content-item">
                    <div className="key">SRC Türü:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{srcTypes.map((item, i) => i+1 === srcTypes.length ? item.value : `${item.value}, ` )}</div>
                        :
                        <InputSelectMultiple data={srcTypes} setData={setSrcTypes} inputWidth={"320px"} labelText="" name={"srcTypes"} options={srcOptions}/>
                    }
                </div>
                {/* <div className="content-item">
                    <div className="key">Adres İlçe/İl:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.ilce}/{uyeItemData.il}</div>
                        :
                        <InputCityTown data={cityTown?.location} setData={setCityTown} inputWidth={"320px"} labelText="" name={"cityTown"}/>
                    }
                </div> */}
                <div className="content-item">
                    <div className="key">Adres:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{adressContent}</div>
                        :
                        <InputTextarea data={adressContent} setData={(e) =>setAdressContent(e.target.value)} inputWidth={"320px"} labelText="" name={"adressContent"}/>
                    }
                </div>
            </div>
            {/* <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => {}}>Kaydet</Btn> */}
            <div className="content-grp">            
                {/* <div className="content-item">
                    <div className="key">Referans Kartı Olsun Mu?:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.IsReferenceCard ? "Evet" : "Hayır"}</div>
                        :
                        <InputSelect data={referanceStatus?.text} setData={setReferanceStatus} inputWidth={"320px"} labelText="Referans Kartı Durumu" name={"referanceStatus"} initialOptions={referanceCardData}/>
                    }
                </div> */}
                {
                    !isUpdateContent && 
                    <>
                        <div className="content-item">
                            <div className="key">Kaydeden Firma:</div>
                            <div className="value">{uyeItemData.createdByCompany}</div>
                        </div>

                    </>
                }
            </div>  
        </div>
        <div className="button-grp">
            {
                isUpdateContent &&
                <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => handleSubmit()}>Güncelle</Btn>
            }
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </Container>
  )
}

export default RegularDriverItemInfos